/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { Fab } from '@material-ui/core';

import { formValidator } from '../../../AppUtil/AppUtil';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import { IIFC } from 'react-iifc';
import { useMediaQuery } from 'react-responsive';
import MobileFooter from '../../Common/Profile/MobileFooter';
import MobileButton from '../../Common/Profile/Button';
import { buttonsData } from './data/buttonsData';
import { hot } from 'react-hot-loader';
const { MOBILE } = window.AppConfig.SCREEN_SIZE;

class CashOutOtpForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_cashOutOtpForm: {
				otp: {
					value: '',
					placeholder: 'OTP',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'OTP is required'
						}
					},
					error_text: ''
				}
			}
		};
	}

	handleInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;
		const bankAccountForm = {
			...this.state._cashOutOtpForm
		};
		const updatedFormElement = {
			...bankAccountForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		bankAccountForm[name] = updatedFormElement;
		this.setState({
			_cashOutOtpForm: bankAccountForm
		});
	};

	formValidator = () => {
		const form = {
			...this.state._cashOutOtpForm
		};
		let [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_cashOutOtpForm: updatedForm
		});
		return isFormValid;
	};

	onSubmitHandler = e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}

		this.props.onOtpSubmit(this.state._cashOutOtpForm.otp.value);
	};

	render() {
		const { classes, t, isLoading, closeProfileScreen } = this.props;
		const { _cashOutOtpForm } = this.state;

		return (
			<IIFC>
				{() => {
					const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE})` });
					return (
						<BaseForm closeProfileScreen={closeProfileScreen} isLoading={isLoading}>
							<Grid alignItems="center" item justify="center" sm={12} xs={12}>
								<Typography
									style={isMobile ? { textAlign: 'center' } : { textAlign: '' }}
									component="h1"
									className="subtitle"
									variant="h5">
									{t('profile.otp')}
								</Typography>
							</Grid>
							<Grid alignItems="center" item justify="center" sm={12} xs={12} className="otp_labels">
								<div className={classes.blockdiv}>
									{buttonsData.map(m => (
										<MobileButton
											key={m.text}
											text={m.text.toLocaleUpperCase()}
											disabled={this.props.payout_otp_type != null}
											className={m.className}
											style={{ width: '100%', border: 'none' }}
											onClick={() => this.props.onOtpTypeSubmit(m.sendTo)}
										/>
									))}

									{isMobile ? null : (
										<>
											<Fab
												aria-label="add"
												className={classes.submit}
												color="primary"
												onClick={() => this.props.onOtpTypeSubmit('email')}
												disabled={this.props.payout_otp_type != null}
												size="medium"
												type="submit"
												variant="extended"
												style={{ marginRight: '1rem' }}>
												Send OTP to your Email
											</Fab>

											<Fab
												aria-label="add"
												className={classes.submit}
												color="primary"
												onClick={() => this.props.onOtpTypeSubmit('mobile')}
												disabled={this.props.payout_otp_type != null}
												size="medium"
												type="submit"
												variant="extended">
												Send OTP to your Mobile
											</Fab>
										</>
									)}
								</div>
							</Grid>
							<Grid alignItems="center" item justify="center" sm={8} xs={12}>
								<TextField
									autoComplete="otp"
									className={classes.displayFlex}
									error={!_cashOutOtpForm.otp.isValid && _cashOutOtpForm.otp.isTouched}
									fullWidth
									helperText={
										!_cashOutOtpForm.otp.isValid && _cashOutOtpForm.otp.isTouched
											? t(_cashOutOtpForm.otp.error_text)
											: ''
									}
									id="otp"
									label={isMobile ? null : 'OTP'}
									placeholder={isMobile ? 'OTP' : null}
									name="otp"
									onChange={this.handleInputChange}
									disabled={this.props.payout_otp_type == null}
									required
									inputProps={{ maxLength: 6 }}
									type="string"
									value={_cashOutOtpForm.otp.value}
									variant="outlined"
								/>
							</Grid>
							{isMobile ? null : (
								<Grid alignItems="center" item justify="center" sm={8} xs={12}>
									<div className={classes.blockdiv}>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											onClick={this.props.closeProfileScreen}
											size="medium"
											type="submit"
											variant="extended"
											style={{ marginRight: '1rem' }}>
											Cancel &nbsp;
										</Fab>
										<Fab
											aria-label="add"
											className={classes.submit}
											color="primary"
											onClick={this.onSubmitHandler}
											disabled={this.props.payout_otp_type == null}
											size="medium"
											type="submit"
											variant="extended">
											Cash Out &nbsp;
										</Fab>
									</div>
								</Grid>
							)}
							<MobileFooter
								className="mt-158"
								textButtonContinue="CASH OUT"
								onClick={this.props.closeProfileScreen}
								hasNext={true}
								onSubmit={this.onSubmitHandler}
								disabled={this.props.payout_otp_type == null}
							/>
						</BaseForm>
					);
				}}
			</IIFC>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(CashOutOtpForm)));
